import React from 'react';
import {connect, useSelector} from 'react-redux'

function useHasPermission(permission) {
    const userPermissions = useSelector(state => state.auth.permissions);

    return userPermissions.includes(permission);
}

export default useHasPermission;